/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMaxIcon16Solid = forwardRef('UiFrameSizeMaxIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.5 2a1 1 0 0 1 1-1H12a3 3 0 0 1 3 3v1.5a1 1 0 1 1-2 0V4a1 1 0 0 0-1-1h-1.5a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M3 10.5a1 1 0 0 0-2 0V12a3 3 0 0 0 3 3h1.5a1 1 0 1 0 0-2H4a1 1 0 0 1-1-1v-1.5Z" }),
        React.createElement("path", { d: "M15 10.5a1 1 0 1 0-2 0V12a1 1 0 0 1-1 1h-1.5a1 1 0 1 0 0 2H12a3 3 0 0 0 3-3v-1.5Z" }),
        React.createElement("path", { d: "M4 1a3 3 0 0 0-3 3v1.5a1 1 0 0 0 2 0V4a1 1 0 0 1 1-1h1.5a1 1 0 0 0 0-2H4Z" })));
});
